import { timelineCase } from "../../../mocks/trendData";

export default function TimelineCase() {
  return (
    <section id="timeline" className="bg-background-50 py-10 md:py-14">
      <div className="container-x grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="section-kicker">深度还原 · 事件脉络</span>
          <h2 className="mt-3 font-heading text-xl font-black leading-snug tracking-tight text-foreground-950 md:text-3xl">
            {timelineCase.eventTitle}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">{timelineCase.intro}</p>
          <a href="#responses" className="btn-ghost mt-6">
            查看各方回应
            <i className="ri-arrow-right-line ml-1" aria-hidden="true"></i>
          </a>
        </div>

        <div className="lg:col-span-8">
          <ol className="relative border-l-2 border-background-200 pl-6 md:pl-8">
            {timelineCase.steps.map((step, idx) => {
              const isLast = idx === timelineCase.steps.length - 1;
              return (
                <li key={step.time} className="relative pb-8 last:pb-0">
                  <span
                    className={`absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full ring-4 ring-background-50 md:-left-[39px] ${
                      isLast ? "bg-accent-500" : "bg-primary-500"
                    }`}
                    aria-hidden="true"
                  ></span>
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                    <span className="rounded-md bg-secondary-100 px-2.5 py-0.5 text-xs font-semibold text-secondary-800">
                      {step.time}
                    </span>
                    <span className="text-sm font-bold text-foreground-950">{step.head}</span>
                    <span className="rounded-full border border-background-300 px-2 py-0.5 text-[11px] text-foreground-500">
                      {step.state}
                    </span>
                  </div>
                  <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{step.text}</p>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}